
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import { Image } from '@ta-interaktiv/contentbricks'

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <h4>W. fällt auf Kreditbetrüger herein</h4>
    <p>
  William W. hat sich verrechnet. Bereits hat er 27’000 Franken von der Kirche in den Umbau seines Lokals gesteckt. Doch
  er braucht 70’000 Franken mehr. Und gerät dabei an Betrüger. Ein Briefwechsel zeigt, wie er bei einer Firma in Lugano
  einen Kredit aufnimmt. Sie erlangt im Voraus 4’500 Franken von ihm, als “Sicherheitsleistung”. Gutgläubig überweist
  der 45-Jährige das Geld. Im Gegenzug erhält er keinen Rappen.
    </p> <Image file={require('images/zumkredit.png')} source='Auszug aus einem Schreiben des Kreditanbieters' mdxType="Image" />
    <p>
  Spätestens jetzt ist allen Stellen klar, dass der Mann geradewegs in eine Krise steuert. Die Kantonspolizei meldet
  sich beim Amt für Justizvollzug und warnt vor der ungünstigen Entwicklung. Es bahne sich “eine Misere” an, ist in
  einem Schreiben nachzulesen. Die Bewährungshilfe stellt fest, William W. habe keinen Franken mehr, fahre ohne Billet
  Bahn, könne seine Versicherungen nicht zahlen. Und der Therapeut berichtet, dass der 45-Jährige mit völlig utopischen
  Einnahmen rechne. Zu befürchten sei ein finanzielles, aber auch ein moralisches Desaster. William W. habe sich
  “einfach komplett in eine Sache verrannt”.
    </p>
    <Image file={require('images/zurbeiz.jpg')} source='Der Therapeut warnte laut einem Brief vor einem Desaster' mdxType="Image" />
    <p>
  Mittlerweile hat auch der Gutachter seine Einschätzung vom Juni ergänzt, weil einige Nachfragen aufgekommen waren. Er
  verweist explizit darauf, dass William W. gegen die gesteckten Regeln verstossen hat. Und er kritisiert das
  Restaurant-Projekt mit der Kirche. Das Lokal sei ein möglicher Treffpunkt für Familien. Es gebe Anhaltspunkte, dass
  der Mann auf diesem Weg einen Zugang zu kindlichen Opfern finden könne. So wie schon früher.{' '}
    </p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;